
let favouriteArtists = null;
let artists = null

export function artistDirectoryElement() {
    return document.querySelector(".artist-directory")
}

export function favouritesListElement() {
    return document.getElementById("favourites-list")
}

export function getFavouriteArtists() {
    if (favouriteArtists) {
        return favouriteArtists;
    }
    favouriteArtists = [];
    const artistList = favouritesListElement()
    if (artistList) {
        artistList.querySelectorAll(".artist").forEach(artistEl => {
            favouriteArtists.push({
                id: artistEl.dataset.artistid,
                name: artistEl.dataset.name || "",
                listingNumber: artistEl.dataset.listingnumber,
                coords: artistEl.dataset.coords,
                address: artistEl.dataset.address,
                addressoverride: artistEl.dataset.addressoverride
            })

        })
    }
    return favouriteArtists
}

export function artistListElement() {
    const dirEl = artistDirectoryElement()
    if (dirEl) {
        return dirEl.querySelector(".artist-list")
    }
}

export function artistProfileElement() {
    return document.querySelector(".artist-profile")
}


export async function getDataFromApi(controllerName, apiName, param) {
    const url = `/api/${controllerName}/${apiName}/${encodeURIComponent(param)}`;
    try {

        const response = await fetch(url);

        // Check if the request was successful (status 200-299)
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }

        // Parse the JSON data
        const data = await response.json();
        return data;

    } catch (error) {
        console.error("Fetch error:", error.message);
    }

}

export function getArtists() {
    if (artists) {
        //console.log("Getting artists from cache")
        return artists;
    }
    //console.log("Getting artists from dom")
    artists = [];
    const artistList = artistListElement()
    if (artistList) {
        artistList.querySelectorAll(".artist").forEach(artistEl => {
            artists.push({
                id: artistEl.dataset.artistid,
                name: artistEl.dataset.name || "",
                logo: artistEl.dataset.logo,
                listingNumber: artistEl.dataset.listingNumber,
                address: artistEl.dataset.address,
                medium: artistEl.dataset.medium,
                href: artistEl.href,
                fullName: artistEl.dataset.artistfullname || "",
                coords: artistEl.dataset.coords,
                location: artistEl.dataset.location,
                nameinurl: artistEl.dataset.nameinurl,
                excludefrommap: artistEl.dataset.excludefrommap === "true",
                key: artistEl.dataset.key,
                logoposition: artistEl.dataset.logoposition,
                focalTop: artistEl.dataset.focaltop,
                summary: artistEl.querySelector(".summary") ? artistEl.querySelector(".summary").innerText : "",
                newToTrail: artistEl.dataset.newtotrail === "true",
                awardWinning: artistEl.dataset.awardwinning === "true",
                valuedMember: artistEl.dataset.valuedmember === "true",
                accessible: artistEl.dataset.accessible === "Wheelchair/ baby buggy accessible",
                openLabourDay: artistEl.dataset.openlabourday === "true",
                openYearRound: artistEl.dataset.openyearround === "true",
                valuedMember: artistEl.dataset.valuedmember === "true"
            })
        })
    }
    return artists
}

export function domReady() {
    return new Promise((resolve) => {
        if (document.readyState === 'interactive' || document.readyState === 'complete') {
            resolve();
        } else {
            document.addEventListener('DOMContentLoaded', resolve, { once: true });
        }
    });
}

// forces the browser to fire a custom event whenever pushState or replaceState is called.
const patchHistory = (type) => {
    const original = history[type];
    return function () {
        const result = original.apply(this, arguments);
        const event = new Event(type);
        event.arguments = arguments;
        window.dispatchEvent(event);
        return result;
    };
};

// Patch both methods
history.pushState = patchHistory('pushState');
history.replaceState = patchHistory('replaceState');
